import _ from "lodash"

export const parseCogsMapping = (label, values) => {
    // values = _.pickBy(values, (items) => items?.expenseAccount !== '' && items?.inventoryAccount !== '')

    label = _.filter(label, item => {
        return _.keys(values).includes(item?.id + '')
    })

    return label?.map(item => {
        return {
            ...item,
            account: values[item?.id]?.inventoryAccount ?? '',
            cogs: values[item?.id]?.expenseAccount ?? ''
        }
    })
}

export const parseAdvancedMapping = (label, values) => {

    if (label?.length === 0) {
        return parseOnlyValues(values)
    }

    // values = _.pickBy(values, (items) => items !== '')

    label = _.filter(label, item => {
        return _.keys(values).includes(item?.id + '')
    })

    return label?.map(item => {
        return {
            ...item,
            account: values[item?.id] ?? ""
        }
    })
}

export const parseIndividualMapping = (options, mapping) => {

    if (options?.length === 0) {
        return parseOnlyValues(mapping)
    }

    return options?.map(items => {
        return {
            id: items.id,
            label: items.name,
            account: mapping ? mapping[items?.id] ?? '' : '',
            type: items?.typeId
        }
    })
}

/** Display label for tax / GL account dropdowns; aligns with getAccounts formatting in dashboardService. */
export const formatAccountDropdownLabel = (items) => {
    const name = items?.name ?? ""
    const accountNumber = items?.accountNumber
    const rawType = items?.type
    const type =
        Array.isArray(rawType) ? rawType.filter(Boolean).join(", ") : rawType
    const numberPart = accountNumber ? `(${accountNumber}) ` : ""
    const typePart = type ? ` - ${type}` : ""
    return `${numberPart}${name}${typePart}`.trim()
}

/** Ant Design Select requires unique `value` per option; API may return duplicate account rows. */
export const dedupeAccountOptionsByValue = (parsedOptions) => {
    const seen = new Set()
    return parsedOptions?.filter((opt) => {
        const v = opt?.value != null && opt?.value !== '' ? String(opt.value) : ''
        if (seen.has(v)) return false
        seen.add(v)
        return true
    }) ?? []
}

export const optionsParser = (options) => {
    const parsed = options?.map((items) => ({
        label: formatAccountDropdownLabel(items),
        value: items?.id != null && items?.id !== '' ? String(items.id) : ''
    }))
    return dedupeAccountOptionsByValue(parsed)
}

export const checkHasValue = (value) => {
    if (!value) {
        return false
    }

    return [...new Set(_.values(value))][0] !== ''
}

export const payloadIndividualParser = (value) => {
    let obj = {}

    for (let i = 0; i < value.length; i++) {
        obj[value[i]?.id] = value[i]?.account ?? ""
    }

    return obj
}

export const payloadPoParser = (value) => {
    let obj = {}

    for (let i = 0; i < value.length; i++) {
        obj[value[i]?.id] = {
            inventoryAccount: value[i]?.account ?? "",
            expenseAccount: value[i]?.cogs ?? "",
        }
    }

    return obj
}

export const parseOnlyValues = (values) => {
    return _.keys(values ?? {})?.map(key => {
        return {
            id: key,
            name: key,
            label: key,
            account: values[key] ?? ''
        }
    })
}